import axios, {AxiosResponse} from "axios";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { User } from "../common/models/User";
import { NavBar } from "../components/NavBar";
import { Table } from "../components/Table/Table";
import { useAuth } from "../hooks/useAuth";

interface VerifyArtistProps {
  theme: string;
  toggleTheme: any;
}

const RevokeLicensesPageContainer = styled.div`
  background: #000D30;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const VerifyArtistsPage: React.FC<VerifyArtistProps> = ({
  theme,
  toggleTheme,
}) => {
  const [pendingArtists, setPendingArtists] =
    useState<User[]>();

    const auth = useAuth();

  useEffect(() => {
    fetchPendingArtists();
  }, []);

  const fetchPendingArtists = async () => {
    const response = await axios.get(
      process.env.REACT_APP_BACKEND_URL + "/get_pending_artists"
    );
    if (response) {
      const artists = response.data.pending_artists as Array<User>;
      setPendingArtists(artists);
      
    }
  };

  const columns = useMemo(
    () => [
        {
            Header: "Stage Name",
            accessor: "stage_name",
          },
      {
        Header: "First Name",
        accessor: "first_name",
      },

      {
        Header: "Last Name",
        accessor: "last_name",
      },

      {
        Header: "Email",
        accessor: "email",
      },

      {
        Header: "Wallet Address",
        accessor: "wallet_address",
      },
      {
        Header: "Description ",
        accessor: "description",
      }
    ],
    []
  );

  const onApproveClick = (user: User) => {

    
    const formData = new FormData();
    formData.append("servicer_address", auth.user.wallet_address);
    formData.append("artist_wallet_address", user.wallet_address);
    axios
    .post(process.env.REACT_APP_BACKEND_URL + "/approve_artist", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response: AxiosResponse) => {
      alert('Artist has been approved!');
      fetchPendingArtists();
      
    });

  };


  return (
    <>
    <NavBar theme={theme} themeToggler={toggleTheme}/>
    <RevokeLicensesPageContainer>
    <h1 style={{marginTop: '5%'}}>Pending Artist</h1>
      {pendingArtists && pendingArtists.length > 0 ? (
        <Table
          columns={columns}
          data={pendingArtists}
          onApproveClick={onApproveClick}
        />
      ): <p>No Artists are pending verification</p>}
    </RevokeLicensesPageContainer>
    </>
  );
};

export default VerifyArtistsPage;
